import React from 'react';
import { motion } from 'framer-motion';
import { EyeOff, Check } from 'lucide-react';
import { useDashboardStore } from '../store/dashboardStore';

export function EditDashboardButton() {
  const { isEditMode, toggleEditMode } = useDashboardStore();

  return (
    <motion.button
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      onClick={toggleEditMode}
      className={`text-xs transition-colors ${
        isEditMode 
          ? 'text-primary' 
          : 'text-muted-foreground hover:text-primary'
      }`}
    >
      {isEditMode ? 'Done' : 'Hide Items'}
    </motion.button>
  );
}